import React from "react";
import { FooterSection } from "./FooterElement";

class Footer extends React.Component {
  render() {
    return (
      <>
        <FooterSection>
          <div className="Container"></div>
        </FooterSection>
      </>
    );
  }
}

export default Footer;
